import { useState } from 'react';
import { useAppStore } from '../stores';
export const useAddHouseholdForm = (onSuccess: () => void) => {
  const { user } = useAppStore(state => state.auth);
  const { addHousehold } = useAppStore(state => state.chores);
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const canSubmit = name.trim().length > 0 && !!user?.uid;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit || isSubmitting) return;

    setIsSubmitting(true);
    try {
      // In the 4-layer rule, the Hook calls the "Store" action (addHousehold)
      await addHousehold(name.trim(), user.uid, user.displayName || '');
      setName('');
      onSuccess();
    } catch (error) {
      console.error('Error adding household:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    name,
    setName,
    handleSubmit,
    isSubmitting,
    canSubmit,
  };
};